import React, { FC } from 'react';
import { useInView } from 'react-hook-inview';
import { useTranslation } from 'react-i18next';

import Mateo from '../../../images/company/Juan Mateo - copia.jpg';
import Pablo from '../../../images/company/Pablo - copia.jpg';
import Pedro from '../../../images/company/Pedro - copia.jpg';
import Juan from '../../../images/company/juan.jpg';
import GhIconBlue from '../../../images/footer/icon-gh-blue.svg';
import GhIconLBlue from '../../../images/footer/icon-gh-lblue.svg';
import LnIconBlue from '../../../images/footer/icon-ln-blue.svg';
import LnIconLBlue from '../../../images/footer/icon-ln-lblue.svg';
import {
  MainStyled,
  Title,
  CardContainer,
  Card,
  AvatarContainer,
  DiagonalBlueData,
} from './style';

interface Props {}

const Team: FC<Props> = () => {
  const { t } = useTranslation();
  const [targetRef, isInViewport] = useInView({
    unobserveOnEnter: true,
  });
  return (
    <MainStyled ref={targetRef}>
      <DiagonalBlueData />
      <div className="container">
        <Title
          dangerouslySetInnerHTML={{
            __html: t('CompanyTeamTitle'),
          }}
        />
        <CardContainer>
          <Card
            className={
              isInViewport ? 'animate__animated animate__fadeInUp' : 'hide'
            }
          >
            <div className="heading">
              <AvatarContainer>
                <img src={Juan} alt="avatar" />
              </AvatarContainer>
              <div className="social">
                <a
                  href="https://www.linkedin.com/in/juan-martin-pampliega/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={LnIconBlue} alt="social" />
                  <img src={LnIconLBlue} alt="social" />
                </a>
                <a
                  href="https://github.com/juanpampliega"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={GhIconBlue} alt="social" />
                  <img src={GhIconLBlue} alt="social" />
                </a>
              </div>
            </div>
            <div className="name">
              <strong>Juan Pampliega</strong>
            </div>
            <div className="role">{t('CompanyTeamMember1Role')}</div>
            <div className="social">
              <a
                href="https://www.linkedin.com/in/juan-martin-pampliega/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LnIconBlue} alt="social" />
                <img src={LnIconLBlue} alt="social" />
              </a>
              <a
                href="https://github.com/juanpampliega"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GhIconBlue} alt="social" />
                <img src={GhIconLBlue} alt="social" />
              </a>
            </div>
          </Card>
          <Card
            className={
              isInViewport
                ? 'animate__animated animate__fadeInUp animate__delay-1s'
                : 'hide'
            }
          >
            <div className="heading">
              <AvatarContainer>
                <img src={Pablo} alt="avatar" />
              </AvatarContainer>
              <div className="social">
                <a
                  href="https://www.linkedin.com/in/plorenzatto/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={LnIconBlue} alt="social" />
                  <img src={LnIconLBlue} alt="social" />
                </a>
                <a
                  href="https://github.com/plorenzatto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={GhIconBlue} alt="social" />
                  <img src={GhIconLBlue} alt="social" />
                </a>
              </div>
            </div>
            <div className="name">
              <strong>Pablo Lorenzatto</strong>
            </div>
            <div className="role">{t('CompanyTeamMember2Role')}</div>
            <div className="social">
              <a
                href="https://www.linkedin.com/in/plorenzatto/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LnIconBlue} alt="social" />
                <img src={LnIconLBlue} alt="social" />
              </a>
              <a
                href="https://github.com/plorenzatto"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GhIconBlue} alt="social" />
                <img src={GhIconLBlue} alt="social" />
              </a>
            </div>
          </Card>
          <Card
            className={
              isInViewport
                ? 'animate__animated animate__fadeInUp animate__delay-2s'
                : 'hide'
            }
          >
            <div className="heading">
              <AvatarContainer>
                <img src={Pedro} alt="avatar" />
              </AvatarContainer>
              <div className="social">
                <a
                  href="https://www.linkedin.com/in/pedro-ferrari-4195a567/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={LnIconBlue} alt="social" />
                  <img src={LnIconLBlue} alt="social" />
                </a>
                <a
                  href="https://github.com/petobens"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={GhIconBlue} alt="social" />
                  <img src={GhIconLBlue} alt="social" />
                </a>
              </div>
            </div>
            <div className="name">
              <strong>Pedro Ferrari</strong>
            </div>
            <div className="role">{t('CompanyTeamMember3Role')}</div>
            <div className="social">
              <a
                href="https://www.linkedin.com/in/pedro-ferrari-4195a567/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LnIconBlue} alt="social" />
                <img src={LnIconLBlue} alt="social" />
              </a>
              <a
                href="https://github.com/petobens"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GhIconBlue} alt="social" />
                <img src={GhIconLBlue} alt="social" />
              </a>
            </div>
          </Card>
          <Card
            className={
              isInViewport
                ? 'animate__animated animate__fadeInUp animate__delay-3s'
                : 'hide'
            }
          >
            <div className="heading">
              <AvatarContainer>
                <img src={Mateo} alt="avatar" />
              </AvatarContainer>
              <div className="social">
                <a
                  href="https://www.linkedin.com/in/juandemonasterio/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={LnIconBlue} alt="social" />
                  <img src={LnIconLBlue} alt="social" />
                </a>
                <a
                  href="https://github.com/jdemonasterio"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={GhIconBlue} alt="social" />
                  <img src={GhIconLBlue} alt="social" />
                </a>
              </div>
            </div>
            <div className="name">
              <strong>Mateo De Monasterio</strong>
            </div>
            <div className="role">{t('CompanyTeamMember4Role')}</div>
            <div className="social">
              <a
                href="https://www.linkedin.com/in/juandemonasterio/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LnIconBlue} alt="social" />
                <img src={LnIconLBlue} alt="social" />
              </a>
              <a
                href="https://github.com/jdemonasterio"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GhIconBlue} alt="social" />
                <img src={GhIconLBlue} alt="social" />
              </a>
            </div>
          </Card>
        </CardContainer>
      </div>
      <DiagonalBlueData />
    </MainStyled>
  );
};

export default Team;
